import { InsuredLocationsSearchRequestQuery } from '@lio/api-types';

export const getInsuredLocationsQuery = (requestParams?: InsuredLocationsSearchRequestQuery) => {
  if (!requestParams) return undefined;
  const { jurisdictionId, offeringId, brokerageId, pageOffset, pageLimit } = requestParams;
  const query = new URLSearchParams();
  if (jurisdictionId) {
    query.append('jurisdictionId', jurisdictionId);
  }
  if (offeringId) {
    query.append('offeringId', offeringId);
  }
  if (brokerageId) {
    query.append('brokerageId', brokerageId);
  }
  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }
  if (pageLimit) {
    query.append('pageLimit', pageLimit.toString());
  }
  return query.toString();
};
